import {
  EVENT_FEED_CATALYST_FILTERS,
  EVENT_FEED_EARNINGS_FILTERS,
  EVENT_FEED_SCENARIO_FILTERS,
  EventFeedFilterGroupKeys,
  EventFeedType,
} from '@toggle/toggle';

import {
  FilterGroups,
  FilterState,
} from '~/hooks/use-filter-actions/useFilterActions';
import { StreamFilterTabs } from '~/views/stream/components/stream-type-tab-line/StreamTypeTabLine';

export const defaultEventFeedFilterState: FilterState = {
  activeFilterOptions: [],
  activeFilters: [],
  allFilters: [],
};

export const defaultEventFeedFilterGroups: FilterGroups<EventFeedFilterGroupKeys> =
  {
    [EVENT_FEED_SCENARIO_FILTERS]: { ...defaultEventFeedFilterState },
    [EVENT_FEED_CATALYST_FILTERS]: { ...defaultEventFeedFilterState },
    [EVENT_FEED_EARNINGS_FILTERS]: { ...defaultEventFeedFilterState },
  };

export const tabToEventFeedFilterGroup: Partial<
  Record<StreamFilterTabs, EventFeedFilterGroupKeys>
> = {
  scenarios: EVENT_FEED_SCENARIO_FILTERS,
  catalysts: EVENT_FEED_CATALYST_FILTERS,
  earnings: EVENT_FEED_EARNINGS_FILTERS,
};

export const tabTypeToEventFeedType: Record<
  StreamFilterTabs,
  EventFeedType | undefined
> = {
  all: undefined,
  catalysts: 'attribution-insight',
  scenarios: 'scenario-insight',
  earnings: 'earnings-insight',
  summaries: 'market-overview',
};

export const defaultEventFeedGroupNameMap: Record<
  EventFeedFilterGroupKeys,
  string
> = {
  [EVENT_FEED_SCENARIO_FILTERS]: 'Scenario',
  [EVENT_FEED_CATALYST_FILTERS]: 'Catalyst',
  [EVENT_FEED_EARNINGS_FILTERS]: 'Earnings',
};
